/**
 * Seeded pseudo-random number generator (LCG).
 * Makes layout selection deterministic per story — same project always
 * renders the same layout sequence, no surprises on re-render.
 */

/** Convert a string to a numeric seed */
export function strToSeed(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // force 32-bit int
  }
  return Math.abs(hash);
}

/** LCG random number generator — returns [0, 1) */
export function createRng(seed: number) {
  let s = seed;
  return {
    next(): number {
      s = (s * 1664525 + 1013904223) & 0xffffffff;
      return (s >>> 0) / 0x100000000;
    },
    /** Pick a random integer in [0, max) */
    int(max: number): number {
      return Math.floor(this.next() * max);
    },
    /** Pick a random item from an array */
    pick<T>(arr: T[]): T {
      return arr[this.int(arr.length)];
    },
    /** Shuffle array in place */
    shuffle<T>(arr: T[]): T[] {
      const a = [...arr];
      for (let i = a.length - 1; i > 0; i--) {
        const j = this.int(i + 1);
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
  };
}
